import { ComplianceCheck, ComplianceCheckType } from '__generated__/graphql';

// The first compliance check of the given type. Types that produce one check
// per tariff flag (e.g. PGA_DISCLAIM) pass a `predicate` to narrow the match.
export const getLatestComplianceCheck = (
  complianceChecks: ComplianceCheck[] | null | undefined,
  type: ComplianceCheckType,
  predicate?: (check: ComplianceCheck) => boolean,
): ComplianceCheck | undefined =>
  complianceChecks?.find(
    (check) => check.type === type && (predicate ? predicate(check) : true),
  );
